import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = {
  key: 0,
  id: "two-screens"
}
const _hoisted_3 = { style: {"float":"left","padding-right":"1rem","height":"100%","min-width":"350px","width":"50%"} }
const _hoisted_4 = { class: "main-screen" }
const _hoisted_5 = {
  key: 1,
  id: "bg-homepage"
}
const _hoisted_6 = {
  key: 1,
  class: "main-screen max-size-1screen"
}
const _hoisted_7 = {
  key: 2,
  class: "max-size-1screen"
}

import { onMounted, onUnmounted, ref } from 'vue';
import HeaderLogo from '@/components/HeaderLogo.vue';
import ConnectivityToast from '@/components/connectivityToast.vue';
import HomePage from './HomePage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {

const reportID = ref<string>('');
const isScreenSizeBiggerThan750px = ref(window.innerWidth > 750);
const handleResize = () => {
    isScreenSizeBiggerThan750px.value = window.innerWidth > 750;
};

onMounted(() => {
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

function handleValueChanged(newValue: string) {
    reportID.value = newValue;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderLogo),
    _createVNode(ConnectivityToast),
    (isScreenSizeBiggerThan750px.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(HomePage, { onValueChanged: handleValueChanged })
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.$route.name != 'homepage')
              ? (_openBlock(), _createBlock(_component_RouterView, { key: reportID.value }))
              : (_openBlock(), _createElementBlock("div", _hoisted_5))
          ])
        ]))
      : (_ctx.$route.name != 'homepage')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_RouterView)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(HomePage)
          ]))
  ]))
}
}

})